import { ArrowRight, ArrowRightAlt, LensBlur, StackedBarChart, Storage } from '@mui/icons-material';
import React, { useContext } from 'react';
import { useEffect } from 'react';
import { Fade } from 'react-reveal';
import { SkillsData } from '../data';
import cpp from '../assets/cpp.png'
import py from '../assets/py.png'
import { Link } from 'react-router-dom';
import AllSkills from './allSkills';
import { useState } from 'react';

function Skills() {
    const [showAllSkills, setShowAllSkills] = useState(false)
    useEffect(() => {
        console.log(SkillsData)
    })

    return (
        <div id="skills">
            <br />
            <Fade left>
                <center>
                    <small className='my_specialties' > MY SPECIALTIES MAINLY GRAVITATES AROUND A PARTICULAR PROGRAMING LANGUAGE (AND MY FIRST LOVE) JAVASCRIPT.</small>
                </center>
            </Fade>
            {
                showAllSkills ?

                    <AllSkills setShowAllSkills={setShowAllSkills} />
                    :
                    <div className='px-2 skillsDark'>
                        <br />

                        <Fade left>

                            <div className="centralize">

                                <div className="wrapper">
                                    <div>
                                        <p className="fw-bold">skills</p>
                                        {/* <div class="loader"></div> */}

                                    </div>

                                    <div>
                                        <div className="replace">
                                            <span>HTML </span>
                                            <span>js </span>
                                            <span>css </span>
                                            <span>node JS </span>
                                            <span>React JS</span>
                                            <span>PHP</span>
                                            <span>SQL</span>
                                            <span>FIREBASE</span>
                                            <span style={{ whiteSpace: 'nowrap' }}>MONGO DB</span>
                                        </div>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setShowAllSkills(true)}
                                style={{ textDecoration: 'none', cursor:'pointer' }}>
                                <div className="view-more mt-3 " >
                                    <main className='ls '>view all skills</main>
                                    <div>
                                        <ArrowRightAlt />
                                    </div>
                                </div>

                            </div >
                        </Fade>
                    </div>



            }

        </div>
    )

}

export default Skills;